import { ComponentType, createElement } from 'react'

type ComponentTree = {
  component: ComponentType
  props: object
  children: ComponentTree | null
}
export function createComponentTreeMap<P extends {}>(
  components: Array<ComponentType<any>> = [],
  props = {} as P
): ComponentTree | null {
  const [component, ...restComponents] = components
  const hasRestComponents = Array.isArray(restComponents) && Boolean(restComponents.length)

  return component
    ? {
        component,
        props,
        children: hasRestComponents ? createComponentTreeMap(restComponents, props) : null,
      }
    : null
}

export function buildComponentTree(componentMap = {} as ComponentTree): JSX.Element | null {
  const { component: Cmp, children, props } = componentMap

  if (!Cmp) {
    return null
  }

  return createElement(Cmp, props, children && buildComponentTree(children))
}



// WEBPACK FOOTER //
// ./src/modules/router/utils.ts